import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import '../../App.css';
import InputData from '../../components/Inputs/InputData/InputData';
import InputSelect from '../../components/Inputs/InputSelect/InputSelect';
import Pagina from '../../components/Pagina/Pagina';
import api from '../../services/api';
import { getFiltroPadraoRelatorioLancamentos } from '../../utils/filtros';
import { gridColumn } from '../../utils/gridColumn';
import { ajustaDatas, optionsDatas } from '../../utils/utils';
import FormikPadrao from '../../components/FormikPadrao/FormikPadrao';
import BarraBotoes from '../../components/BarraBotoes/BarraBotoes';
import TotalizadorRelatorio from '../../components/TotalizadorRelatorio/TotalizadorRelatorio';
import Tabela from '../../components/Tabela/Tabela';
import InputFiltro from '../../components/Inputs/InputFiltro/InputFiltro';
import Filtros from '../../components/Filtros/Filtros';
import InputAutoComplete from '../../components/Inputs/InputAutoComplete/InputAutoComplete';
import { getSomaListaFloat } from '../../utils/decimalMath';
import { baixarArquivoBase64 } from '../../utils/download';

function RelLancamentos() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [search] = useSearchParams();
  const [searchBar, setSearchBar] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [relLancamentos, setRelLancamentos] = useState([]);
  const [totalReceitasPrevistas, setTotalReceitasPrevistas] = useState(0);
  const [totalReceitasPagas, setTotalReceitasPagas] = useState(0);
  const [totalDespesasPrevistas, setTotalDespesasPrevistas] = useState(0);
  const [totalDespesasPagas, setTotalDespesasPagas] = useState(0);

  async function GetRelLancamentos(filtros) {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(filtros, null, 2),
    };
    let res = await api.post('/LancamentoReport/GetList', payload);
    let data = res.data;
    if (res.status === 200) {
      setRelLancamentos(data.Lancamentos);
      if (data.Lancamentos && Object.keys(data.Lancamentos).length > 0) {
        var lancamentos = data.Lancamentos;
        var receitas = lancamentos.filter(q => q.Tipo === 'Receita');
        var despesas = lancamentos.filter(q => q.Tipo === 'Despesa');
        setTotalReceitasPagas(getSomaListaFloat(receitas, 'ValorPago'));
        setTotalReceitasPrevistas(getSomaListaFloat(receitas, 'ValorTotal'));
        setTotalDespesasPagas(getSomaListaFloat(despesas, 'ValorPago'));
        setTotalDespesasPrevistas(getSomaListaFloat(despesas, 'ValorTotal'));
      } else {
        setTotalReceitasPagas(0);
        setTotalReceitasPrevistas(0);
        setTotalDespesasPagas(0);
        setTotalDespesasPrevistas(0);
      }
      setLoading(false);
    } else {
      alert('Erro ao buscar dados');
    }
  }

  useEffect(() => {
    GetRelLancamentos(getFiltroPadraoRelatorioLancamentos());
  }, []);

  useEffect(() => {
    if (search.get('filter')) {
      setShowFilters(search.get('filter') === 'true');
      GetRelLancamentos(getFiltroPadraoRelatorioLancamentos());
    }
  }, [search]);

  function handleEdit(item) {
    navigate(`/Lancamentos/Editar/${item.Id}`);
  }

  const getPDF = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relLancamentos, null, 2),
    };
    baixarArquivoBase64('/LancamentoReport/GetPDF', payload);
  };

  const getExcel = async () => {
    let payload = {
      database: localStorage.getItem('database'),
      data: JSON.stringify(relLancamentos, null, 2),
    };
    baixarArquivoBase64('/LancamentoReport/GetExcel', payload);
  };

  return (
    <Pagina loading={loading}>
      <FormikPadrao
        initialValues={getFiltroPadraoRelatorioLancamentos()}
        onSubmit={async values => {
          await GetRelLancamentos(values);
        }}
      >
        <BarraBotoes
          maxWindowSize={1030}
          botoes={[
            {
              children: 'Exportar Planilha',
              onClick: getExcel,
              variant: 'verde',
            },
            {
              children: 'Exportar PDF',
              onClick: getPDF,
              variant: 'rosa',
            },
          ]}
          search={{
            placeholder: 'Procurar por lançamentos',
            onChange: e => setSearchBar(e.target.value),
          }}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
        />
        <FilterMenu showFilters={showFilters} setShowFilters={setShowFilters} />
        <TotalizadorRelatorio
          items={[
            {
              Titulo: 'TOTAL DE RECEITAS PREVISTAS',
              Valor: totalReceitasPrevistas,
              type: 'money',
            },
            {
              Titulo: 'TOTAL DE RECEITAS PAGAS',
              Valor: totalReceitasPagas,
              type: 'money',
            },
            {
              Titulo: 'TOTAL DE DESPESAS PREVISTAS',
              Valor: totalDespesasPrevistas,
              type: 'money',
            },
            {
              Titulo: 'TOTAL DE DESPESAS PAGAS',
              Valor: totalDespesasPagas,
              type: 'money',
            },
          ]}
        />
        <Tabela
          titulo={'RELATÓRIO DE LANÇAMENTOS FINANCEIROS'}
          setFunction={setRelLancamentos}
          data={relLancamentos}
          columns={[
            {
              placeholder: 'CÓDIGO',
              name: 'Codigo',
              type: 'text',
            },
            {
              placeholder: 'EMPRESA',
              name: 'Empresa',
              type: 'text',
            },
            {
              placeholder: 'TIPO',
              name: 'Tipo',
              type: 'text',
            },
            {
              placeholder: 'CLIENTE',
              name: 'Cliente',
              type: 'text',
            },
            {
              placeholder: 'PLANO DE CONTAS',
              name: 'PlanoConta',
              type: 'money',
            },
            {
              placeholder: 'CENTRO DE CUSTOS',
              name: 'CentroCustos',
              type: 'text',
            },
            {
              placeholder: 'Nº DOCUMENTO',
              name: 'Documento',
              type: 'text',
            },
            {
              placeholder: 'BANCO',
              name: 'Banco',
              type: 'text',
            },
            {
              placeholder: 'PAGO',
              name: 'Pago',
              type: 'text',
            },
            {
              placeholder: 'DESCRIÇÃO',
              name: 'Descricao',
              type: 'text',
            },
            {
              placeholder: 'COMPETÊNCIA',
              name: 'DataCompetencia',
              type: 'date',
            },
            {
              placeholder: 'VENCIMENTO',
              name: 'DataVencimento',
              type: 'date',
            },
            {
              placeholder: 'VALOR',
              name: 'ValorTotal',
              type: 'money',
            },
            {
              placeholder: 'VALOR PAGO',
              name: 'ValorPago',
              type: 'money',
            },
          ]}
          searchBar={searchBar}
          handleEdit={handleEdit}
        />
      </FormikPadrao>
    </Pagina>
  );
}

function FilterMenu({ showFilters, setShowFilters }) {
  const { values, setFieldValue } = useFormikContext();

  const optionsData = [
    { value: 'vencimento', name: 'Regime de caixa (vencimento)' },
    { value: 'competencia', name: 'Filtrar Por Data de Competência' },
    { value: 'pagamento', name: 'Filtrar Por Data de Pagamento' },
  ];

  const optionsLancamentos = [
    { value: '', name: 'Tipo do lançamento' },
    { value: 'Receita', name: 'Receita' },
    { value: 'Despesa', name: 'Despesa' },
  ];

  const optionsSituacao = [
    { value: '', name: 'Situação' },
    { value: 'true', name: 'Pago' },
    { value: 'false', name: 'Não Pago' },
  ];

  useEffect(() => {
    ajustaDatas(values.PeriodoLancamento, setFieldValue);
  }, [values.PeriodoLancamento, setFieldValue]);

  return (
    <Filtros showFilters={showFilters} setShowFilters={setShowFilters}>
      <InputFiltro
        titulo="CLIENTE/FORNECEDOR"
        id="Cliente"
        name="Cliente"
        component={InputAutoComplete}
        autocomplete={true}
        path={'ClienteFornecedor'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="EMPRESA"
        id="Empresa"
        name="Empresa"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Empresa'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="BANCO"
        id="Banco"
        name="Banco"
        component={InputAutoComplete}
        autocomplete={true}
        path={'Bancos'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="TIPO DO LANÇAMENTO"
        id="TipoLancamento"
        name="TipoLancamento"
        component={InputSelect}
        options={optionsLancamentos}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="SITUAÇÃO"
        id="Pago"
        name="Pago"
        component={InputSelect}
        options={optionsSituacao}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PLANO DE CONTAS"
        id="PlanoConta"
        name="PlanoConta"
        component={InputAutoComplete}
        autocomplete={true}
        path={'PlanosContas'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="CENTRO DE CUSTOS"
        id="CentroCustos"
        name="CentroCustos"
        component={InputAutoComplete}
        autocomplete={true}
        path={'CentroCustos'}
        database={localStorage.getItem('database')}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="FILTRAR POR DATA"
        id="TipoData"
        name="TipoData"
        component={InputSelect}
        options={optionsData}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="PERÍODO"
        id="PeriodoLancamento"
        name="PeriodoLancamento"
        component={InputSelect}
        options={optionsDatas}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Inicial"
        id="DataInicial"
        name="DataInicial"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
      <InputFiltro
        titulo="Data Final"
        id="DataFinal"
        name="DataFinal"
        component={InputData}
        gridColumn={gridColumn.gc4}
      />
    </Filtros>
  );
}

export default RelLancamentos;
